// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fEbu9","left":"styles_left__20jnu","desktopActions":"styles_desktopActions__YWqQ0","title":"styles_title__pEeOS"};